<template>
  <div v-if="model && model.length">
    <div class="m-b-9">Opening hours:</div>
    <table>
      <tr v-for="(item, index) in getmodel(model)" :key="index">
        <td>{{ insertString("FindStore", getDayString(item.Days)) }}:</td>
        <td>
          <span>{{ item.OpenHour }}</span>
          <span v-if="item.OpenMinute">.{{ item.OpenMinute }}</span> -
          <span>{{ item.CloseHour }}</span>
          <span v-if="item.CloseMinute">.{{ item.CloseMinute }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    model: Array
  },
  methods: {
    getmodel (data) {
      const list = data.filter(x => x.Date === null);
      list.sort(function (a, b) {
        if (a.Days < b.Days) return -1;
        if (a.Days > b.Days) return 1;
        return 0;
      });
      return list;
    },
    getDayString (val) {
      return {
        0: 'AllDays',
        1: 'WeekDays',
        2: 'Mon',
        3: 'Tue',
        4: 'Wed',
        5: 'Thu',
        6: 'Fri',
        7: 'Sat',
        8: 'Sun'
      }[val];
    }
  }
};
</script>
